////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const KioskPricesManagerTransmitStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
	padding: 0px 10px;
`
//////STYLED//////

const KioskPricesManagerTransmitStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskPricesManagerTransmitStatusWrapper colorCode={props.row.totransmitStatus.colorCode}>
			{translations[props.row.totransmitStatus.translationKey]}
		</KioskPricesManagerTransmitStatusWrapper>
	)
}

KioskPricesManagerTransmitStatus.propTypes = {}

KioskPricesManagerTransmitStatus.defaultPropTypes = {}

export default KioskPricesManagerTransmitStatus
